export const pdfFields = [
  {
    id: 'primaryCaregiver',
    label: 'Primary Caregiver Information',
    subfields: [
      {
        id: 'address',
        label: 'Address',
      },
      {
        id: 'phone',
        label: 'Primary Phone Number',
      },
      {
        id: 'email',
        label: 'Email Address',
      },
    ],
  },
  {
    id: 'emergencyContact',
    label: 'Emergency Contact Information',
  },
  {
    id: 'patient',
    label: 'Child Information',
    subfields: [
      {
        id: 'birthday',
        label: 'Birthdate / Age',
      },
      {
        id: 'gender',
        label: 'Gender',
      },
      {
        id: 'address',
        label: 'Address',
      },
    ],
  },
  {
    id: 'insurance',
    label: 'Insurance',
  },
  {
    id: 'primaryCareProvider',
    label: 'Primary Doctor',
  },
  {
    id: 'otherContact',
    label: 'Other Contact Information',
  },
  {
    id: 'specialist',
    label: 'Specialists',
  },
  {
    id: 'diagnosis',
    label: 'Diagnoses',
  },
  {
    id: 'allergy',
    label: 'Allergies',
  },
  {
    id: 'diet',
    label: 'Diet',
  },
  {
    id: 'pharmacy',
    label: 'Pharmacies',
  },
  {
    id: 'surgery',
    label: 'Surgeries',
  },
  {
    id: 'prescription',
    label: 'Medications',
  },
];



// WEBPACK FOOTER //
// ./src/modules/PDFSettingsPage/constants.js